import { Routes } from '@angular/router';

import { NavbarComponent } from './navbar.component';
import { HelpComponent } from '.././help/help.component';
import { GlobalSearchComponent } from '.././global-search/global-search.component';
import { UserNotificationComponent } from '.././user-notification/user-notification.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
export const navbarRoute: Routes = [
  {
    path: '',
    component: NavbarComponent,
    outlet: 'navbar'
  },
  {
    path: 'help',
    component: HelpComponent,
    data: { title: 'Help' }
  },
  {
    path: 'notification',
    component: UserNotificationComponent,
    data: { title: 'Notification' }
  },
  {
    path: 'search',
    component: GlobalSearchComponent,
    data: { title: 'Search' }
  },
  {
    path: 'reset',
    component: ResetPasswordComponent,
    outlet: 'navbar',
    data: { title: 'reset' }
  },
  
];



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.route.ts